export const monifyInputField = (value: string | number) => {
    let parsedValue = String(value).replace(/[^0-9]/g, "");

    // Format the number with commas
    parsedValue = parsedValue.replace(/\B(?=(\d{3})+(?!\d))/g, ",");

    return parsedValue;
};
